import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import CircleIconButton from '@ts/ui/CircleIconButton';

export const Navbar = styled.div`
    padding: 0;
    z-index: 100;
    width: 100%;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 4px;
    background-color: rgb(43, 59, 70);
    position: relative;
`;

export const Wrapper = styled.div`
    padding: 0 10px 0 10px;
    display: flex;
    justify-content: left;
    align-items: center;
    height: 80px;
`;

export const BrandLink = styled(Link)`
    position: static !important;
    margin-left: 12px;
    display: flex;
    padding-left: 12px;
    align-items: center;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 535px) {
        svg {
            width: 135px;
        }
    }
    width: 164px;
    height: 42px;
`;

export const Actions = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${CircleIconButton} {
        margin: 0;
    }
    ${CircleIconButton}:last-child {
        margin-left: 10px;
    }
    &.actions {
        left: 0;
    }
`;

export const PartnersLink = styled.a.attrs({
    target: '_blank',
    rel: 'noreferer noopener',
})`
    display: none;
    height: 41px;
    margin-right: 15px;
    -webkit-font-smoothing: antialiased;
    font-family: Montserrat, Helvetica, Arial, Lucida, sans-serif;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    background: none;
    padding: 5px 14px;
    border: none;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.7em !important;
    transition: all ease 0.2s;
    text-shadow: none;
    text-decoration: none;
    color: #fff !important;
    background-color: transparent;
    opacity: 0.75;
    &:hover,
    &:active {
        text-decoration: none;
    }
    &:hover {
        opacity: 1;
    }
    @media only screen and (min-width: 992px) {
        ${(props) =>
            props.transparent &&
            css`
                display: block;
            `}
        ${(props) =>
            !props.transparent &&
            css`
                display: none;
            `}
    }

    @media only screen and (min-width: 1150px) {
        display: block;
    }
`;
export const IconMenuWrapper = styled.div`
    &:hover {
        cursor: pointer;
    }
`;
